module.exports = "<template>\n    <div class=\"gmr-display\">\n        <pre textcontent.bind=\"text\"></pre>\n    </div>\n</template>\n";